import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import * as FaIcons from 'react-icons/fa';
import './TopMenuBar.css';
import { AuthContext } from '../user/AuthContext';

export default function TopMenuBar({
  onOpenPopup,
  gestureEnabled,
  onToggleGesture
}) {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  let Avatar;
  if (user?.photoURL) {
    Avatar = <img src={user.photoURL} alt="avatar" className="profile-avatar-img" />;
  } else if (user?.iconName && FaIcons[user.iconName]) {
    const IconComp = FaIcons[user.iconName];
    Avatar = <IconComp size={24} className="profile-icon" />;
  } else {
    Avatar = <FaIcons.FaUserCircle size={24} className="profile-icon" />;
  }

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div className="menuBar">
      <div className="left-menu">
        <Link to="/" className="logo">LEXTRACK AI</Link>
      </div>

      <div className="menuItems">

         {/* ← Hand-control toggle immediately before “Our Company” */}
        <div className="gesture-toggle-wrapper">
          <label className="gesture-switch">
            <input
              type="checkbox"
              checked={gestureEnabled}
              onChange={onToggleGesture}
            />
            <span className="slider" />
          </label>
          <span className="label-text">Hand Control</span>
        </div>
        
        <Link to="/our-company" className="link">Our Company</Link>
        <Link to="/lexacquire"   className="link">Marketplace</Link>

       

        {!user ? (
          <Link to="/login" className="link">Login</Link>
        ) : (
          <>
            <span
              className="profile-icon-wrapper"
              onClick={() => navigate('/profile')}
              style={{ cursor: 'pointer', marginLeft: '20px' }}
            >
              {Avatar}
            </span>
            <button
              onClick={handleLogout}
              className="logout-button"
              style={{ marginLeft: '10px' }}
            >
              Log out
            </button>
          </>
        )}
      </div>
    </div>
  );
}
